/* import __COLOCATED_TEMPLATE__ from './disabled-icon.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "span",
  classNameBindings: [":fa-stack"],
});
